/*
 * toTop class for a clickable to top link
 *
 * Version: 1.0
 *
 * Author: Zwaar Contrast
 *
 * Contact: postduif@zwaarcontrast.nl
 *
 * Dependencies: jQuery (1.11.x)
 *
 * Optional libraries: TweenLite in conjunction with plugins.TweenPlugin, jquery UI for special easing
 * 
 */
(function($, window, document, undefined) {
	"use strict";

	/*
	 * 	In the constructor we wrap the element on which the plugin is called on in a jQuey object 
	 *	and expose the passed on options for usage in the init function
	 */
	var ToTop = function(elem, options) {
		this.el = elem;
		this.element = $(elem);
		this.options = options;
	};

	ToTop.prototype = {

		/*
		 *	Default values, which can be overwritten by merging with config on initialisation
		 */
		defaults:{
			'mode':'speed', 					//Either speed or fixed
			'duration': 1500, 					//Will be used when mode is fixed (in ms)
			'speed': 3.5,						//Will be used when mode is speed (between 1 and 3 works best)
			'jqEasing': 'linear',				//Will be used when TweenLite is not detected, and jQueryUI easing not detected
			'uiEasing':'easeOutExpo',			//Will be used when TweenLite is not detected, and jQueryUI easing is detected
			'tlEasing':'Power2.easeInOut',		//Will be used when TweenLite is detected
			'delay':0,							//Optional delay
			'resizeDebounce':200,				//Debounce value for evaluating document height
			'visibleClass':'is-to-top-visible'	//Class set to element to indicate visibility (shown)
		},

		/*
		 *	Initialisation funtion, read passed config and call necessary functions to launch our plugin like binding events and setting status variables
		 */
		init: function() {
			//Get the options and merge with defaults
			this.config = $.extend({}, this.defaults, this.options);

			//Status
			this.mode = this.getMode();
			this.visible = false;
			
			//Determine shizzle
			this.easing = this.getEasing();

			//Call functions for initialisation
			this.getElements();
			this.bindClick();
			this.bindResize();
			this.checkVisibility();

			return this;
		},
		getElements:function(){
			this.window = $(window);
			this.body = $('body');
		},
		getEasing : function(){
			//Determine easing
			if(typeof TweenLite !== 'undefined'){
				return this.config.tlEasing;
			}else if($.easing && $.easing[this.config.uiEasing]){
				return this.config.uiEasing;
			}else{
				return this.config.jqEasing;
			}
		},
		getMode:function(){
			if(typeof TweenLite !== 'undefined'){
				return 'tween';
			}else{
				return 'animate';
			}
		},
		checkVisibility:function(){
			//Check if the height of the page is smaller than the window (getPageHeight will be equal to window if smaller so check with smaller or equal)
			if(this.getPageHeight()<=this.window.height()){
				this.setVisibility(false)
			}else{
				this.setVisibility(true)
			}
		},
		setVisibility:function(visible){
			//Don't set if same as current 
			if(visible !== this.visible){
				if(visible){
					this.element.addClass(this.config.visibleClass);
					this.visible =visible;
				}else{
					this.element.removeClass(this.config.visibleClass);
					this.visible =visible;
				}
			}
		},
		bindClick:function(){
			//Variables and reference to self
			var _self = this;

			//Bind click
			this.element.click(function(ev){
				ev.preventDefault();
				_self.doScroll();
				dataLayer.push({'event':'GAevent', 'eventCategory':'Interaction', 'eventAction':'To Top', 'eventLabel':'Scroll to top' });
				return false;
			});
		},
		bindResize:function(){
			var TO = false, _self = this;
			this.window.resize(function() {
				if (TO !== false){
					clearTimeout(TO);
				}
				TO = setTimeout(function(){
					//Do stuff here
					_self.checkVisibility();					
				}, _self.config.resizeDebounce);
			});
		},
		getPageHeight: function(){
			return Math.max($(document).height(),$(window).height(),document.documentElement.clientHeight);
		},
		doScroll: function(){
			var duration;			

			//Determine duration
			if(this.config.mode == 'speed'){
				this.pageHeight = this.getPageHeight();
				duration = this.pageHeight / this.config.speed;
			}else if(this.config.mode =='fixed'){
				duration = this.config.duration;
			}
			//Determine mode
			if(this.mode=='tween'){
				TweenLite.to(window, duration/1000, {scrollTo:{y:0},delay:this.config.delay/1000,ease:this.easing});
			}else{	
				$('html, body').delay(this.config.delay).animate({
					scrollTop: 0
				}, duration, this.easing);
			}
		}
	};

	//Extend Jquery with the LinkPositioner function/object
	$.fn.ToTop = function(options) {
		//Do for each of the passed elements
		return this.each(function() {
			//Construct new LinkPositioner object and call initialisation function
			new ToTop(this, options).init();
		});
	};
})(jQuery, window, document);